import { PortalContext, usePortalSettingSet } from "../../../context/portal-context";
import usePageTitle from "../../../hooks/use-page-title";
import { useContext, useEffect, useState } from "react";
import AppUserContext from "../../../context/app-user-context";
import AppUser from "../../../modules/app-user/app-user";
import { showLabelInfo } from "../../../config/methods";
import { TSubmissionListItem } from "../../../modules/api/submission";
import { SUBMISSION_WL } from "../../../config/constants";
import PDStatistics from "../../../components/portal/PDStatistics";
import ReportItemListing from "../../../components/portal/ReportItemListing";

export default function PageProgress() {
  const title = "My Progress";
  usePageTitle(title);
  usePortalSettingSet("label_header", title);
  const { setCustomText } = useContext(PortalContext);
  useEffect(() => {
    setCustomText(title);
  }, []);
  const user = useContext(AppUserContext);

  const programmeName =
    user.activeGroup &&
    user.activeGroup._id &&
    user.groupHash[user.activeGroup._id]
      ? user.groupHash[user.activeGroup._id].cohort.programme.name
      : "";

  useEffect(() => {
    AppUser.refreshUser(["avatar"]);
  }, []);

  return (
    <main
      className="content-generic content-generic--fluid"
      data-comp="PageProgress"
    >
      {/* <h1 className="fs-title">My Progress</h1> */}

      <div className="d-flex gap-3 bg-white p-3 rounded-4 shadow-sm">
        <ul className="contact-detail-list student-profile-list">
          {/* <li>
            <div>Student ID</div>
            <div>{showLabelInfo(user.studentId)}</div>
          </li> */}
          <li>
            <div>Student Name</div>
            <div>{showLabelInfo(user.name)}</div>
          </li>
          <li>
            <div>Programme</div>
            <div>{showLabelInfo(programmeName)}</div>
          </li>
          <li>
            <div>Cohort Name</div>
            <div>{showLabelInfo(user.activeCohort.name)}</div>
          </li>
          <li>
            <div>Job Title</div>
            <div>{showLabelInfo(user.jobTitle)}</div>
          </li>
          <li>
            <div>Employer</div>
            <div>{showLabelInfo(user.organizationName)}</div>
          </li>
          <li>
            <div>Industry Supervisors</div>
            <div>{showLabelInfo(user?.supervisors?.industry)}</div>
          </li>
          <li>
            <div>SIT Supervisors</div>
            <div>{showLabelInfo(user?.supervisors?.sit)}</div>
          </li>
        </ul>
      </div>

      <div className="my-3">
        <div className="flex-grow-1 bg-white p-3 rounded-4 shadow-sm">
          {user.activeCohort.pdMode && (
            <PDStatistics
              cohortId={user.activeCohort._id}
              studentId={user.referenceUserId}
            />
          )}

          <ReportItemListing
            className="mt-3 report-item-listing--progress-page"
            userId={user.referenceUserId}
            cohortId={user.activeCohort._id}
            itemsPerPage={10}
            pagination={true}
            type={user.activeCohort.pdMode ? "" : SUBMISSION_WL}
            status="Publish"
          />
        </div>
      </div>
    </main>
  );
}
